import { render, staticRenderFns } from "./ComplianceTable.vue?vue&type=template&id=377e3f36"
import script from "./ComplianceTable.vue?vue&type=script&lang=js"
export * from "./ComplianceTable.vue?vue&type=script&lang=js"
import style0 from "./ComplianceTable.vue?vue&type=style&index=0&id=377e3f36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports